import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    activityTypeItems: [],
  },
  getters: {
    activityTypeItems (state) {
      return state.activityTypeItems
    }
  },
  mutations: {
    SET_ACTIVITY_TYPE_ITEMS (state, payload) {
      state.activityTypeItems = payload
    }
  },
  actions: {
    loadActivityTypeItems ({ commit, dispatch }, payload) {
      console.log('-> loadActivityTypeItems')
      Vue.axios.get(`${config.serverURI}/activityTypes`).then((response) => {
        commit('SET_ACTIVITY_TYPE_ITEMS', response.data)
      }).catch((error) => {
        console.log('loadActivityTypeItems', error)
      })
    },
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activityTypes`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/activityTypes/page`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/activityTypes/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/activityTypes`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/activityTypes/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/activityTypes/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/activityType.js